import React, { lazy, Suspense, useEffect } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import './App.css';
import Header from './components/utils/Header';
import Loader from './components/utils/loader';
import ServicesPage from './pages/ServicesPage';

// Lazy load the components
const LazyHomePage = lazy(() => import('./pages/Home/HomePage'));

// Component to scroll to top on route change
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0, { behavior: 'instant' });
  }, [pathname]);

  return null;
}

function App() {
  return (
    <div className="App">
      <ScrollToTop />
      <Header />
      <Suspense fallback={<Loader />}>
        <Routes>
          <Route path='/' element={<LazyHomePage />} />
          <Route path='/rooms' element={<ServicesPage />} />
        </Routes>
      </Suspense>
    </div>
  );
}

export default App;
